import { graphql } from 'gatsby';
import React from 'react';
import PropTypes from 'prop-types';

import AnythingCards from '~/components/blocks/acf/AnythingCards';

import product1 from '~/images/exampleBlocks/product1.png';
import product2 from '~/images/exampleBlocks/product2.png';
import product3 from '~/images/exampleBlocks/product3.png';

const AnythingCardsBlock = ({
    attributes,
    globalBlockOptions,
    blockAnythingCards: { cards }
}) => <AnythingCards {...{ attributes, globalBlockOptions, cards }} />;

AnythingCardsBlock.propTypes = {
    blockAnythingCards: PropTypes.shape({
        cards: PropTypes.arrayOf(
            PropTypes.shape({
                title: PropTypes.string.isRequired,
                badge: PropTypes.string,
                description: PropTypes.string.isRequired,
                image: PropTypes.shape({
                    sourceUrl: PropTypes.string.isRequired,
                    altText: PropTypes.string.isRequired,
                    localFile: PropTypes.shape({
                        childImageSharp: PropTypes.shape({
                            gatsbyImageData: PropTypes.object.isRequired
                        }).isRequired
                    })
                }).isRequired,
                link: PropTypes.shape({
                    url: PropTypes.string.isRequired,
                    target: PropTypes.string
                }).isRequired
            })
        ).isRequired
    }).isRequired
};

export default AnythingCardsBlock;

export const query = graphql`
    fragment AnythingCardsBlockFragment on WpAcfAnythingCardsBlock {
        name
        attributes {
            anchor
            className
        }
        globalBlockOptions {
            globalBlockOptions {
                marginBottom
            }
        }
        blockAnythingCards {
            cards {
                title
                badge
                description
                image {
                    sourceUrl
                    altText
                    localFile {
                        childImageSharp {
                            gatsbyImageData
                        }
                    }
                }
                link {
                    url
                    target
                }
            }
        }
    }
`;

export const exampleData = [
    {
        variant: 'Default Anything Cards',
        description:
            'Scroll syned carousel of cards, can be used with arbitrary content. Limited to 3 cards.',
        props: {
            name: 'acf/anything-cards',
            blockAnythingCards: {
                cards: [
                    {
                        title: 'Product Title',
                        badge: 'Interior/Exterior',
                        description: 'Lorem Ipsum short description.',
                        image: {
                            sourceUrl: product1,
                            altText: 'Product 1'
                        },
                        link: {
                            url: '#'
                        }
                    },
                    {
                        title: 'Full Service Wash',
                        badge: 'Exterior',
                        description:
                            "Autobell's signature full service interior cleaning and exterior wash with hand-dry.",
                        image: {
                            sourceUrl: product2,
                            altText: 'Product 2'
                        },
                        link: {
                            url: '#'
                        }
                    },
                    {
                        title: 'Anything Card',
                        badge: 'Badge',
                        description:
                            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
                        image: {
                            sourceUrl: product3,
                            altText: 'Product 3'
                        },
                        link: {
                            url: '#'
                        }
                    }
                ]
            }
        }
    }
];
